import { render, staticRenderFns } from "./Partner-Layout.vue?vue&type=template&id=756d94e1&scoped=true&"
import script from "./Partner-Layout.vue?vue&type=script&lang=js&"
export * from "./Partner-Layout.vue?vue&type=script&lang=js&"
import style0 from "./Partner-Layout.vue?vue&type=style&index=0&id=756d94e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d94e1",
  null
  
)

export default component.exports